/* eslint-disable no-script-url, jsx-a11y/anchor-is-valid */
import React from "react";
import "../AdminSidebar/AdminSidebar.css";
import authenticationService from "../../_services/authentication.service";
import { history } from "../../_helpers/history";
import * as Constants from "../../_constants/accessoryfinder.constants";
class AdminSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: authenticationService.currentUserValue,
      addClass: false,
      isAccountOpen: false,
      adminMenu: Constants.ADMIN_MENULIST,
      selectedPath: window.location.pathname,
    };
  }

  componentDidMount() {
    let foundadminMenuItem = this.state.adminMenu.find(
      (item) => item.href === this.state.selectedPath
    );
    if (foundadminMenuItem !== undefined) {
      let filteredArray = this.state.adminMenu.filter(
        (item) => item.href !== this.state.selectedPath
      );
      foundadminMenuItem.cssClass = "sidebar-dropdown active";
      filteredArray.push(foundadminMenuItem);
      this.setState({
        adminMenu: filteredArray.sort((a, b) => a.Order - b.Order),
      });
    } else {
      // let foundadminSubMenuItem = this.state.adminMenu.find(item => item.name === 'account-management')
      // if(foundadminSubMenuItem)
      // {
      //   console.log('1',foundadminSubMenuItem);
      //   let filteredSubArray = foundadminSubMenuItem.subMenu.filter(item => item.href !== this.state.selectedPath)
      //   let filterSubMenuItem = foundadminSubMenuItem.subMenu.filter(item => item.href === this.state.selectedPath);

      //   filterSubMenuItem.subMenucssClass = 'activeSubmenu';
      //   console.log('filterSubMenuItem',filterSubMenuItem);
      //   filteredSubArray.push(filterSubMenuItem);
      //   foundadminSubMenuItem.subMenu = filteredSubArray.sort((a, b) => a.Order - b.Order);

      //   console.log('2',foundadminSubMenuItem);
      // }

      this.setState({ isAccountOpen: !this.state.isAccountOpen });
    }
  }

  handleLogoutClick = (e) => {
    authenticationService.logout();
    history.push("/admin-login");
  };

  dropdownClick = (value) => {
    if (value === "accountmanagement") {
      this.setState({ isAccountOpen: !this.state.isAccountOpen });
    }
    return false;
  };

  render() {
    const { currentUser, isAccountOpen, adminMenu } = this.state;
    const { handleClick } = this.props;

    return (
      <React.Fragment>
        <a
          id="show-sidebar"
          className="btn btn-sm btn-dark"
          href="Javascript:void(0)"
          onClick={handleClick}
        >
          <i className="fa fa-bars"></i>
        </a>
        <nav id="sidebar" className="sidebar-wrapper">
          <div className="sidebar-content">
            <div className="sidebar-brand">
              <a href="#">WMT Admin</a>
              <div id="close-sidebar" onClick={this.props.handleClick}>
                <i className="fa fa-times"></i>
              </div>
            </div>
            <div className="sidebar-header">
              <div className="user-info">
                <span className="user-name">
                  {currentUser?.firstName}
                  <strong> {currentUser?.lastName}</strong>
                  <span className="user-role"> ({currentUser?.role})</span>
                </span>
                <span className="user-status">
                  <a href="/admin-login" onClick={this.handleLogoutClick}>
                    <i className="fa fa-power-off"></i>
                    <span>Logout</span>
                  </a>
                </span>
              </div>
            </div>
            <div className="sidebar-menu">
              <ul>
                {adminMenu.length &&
                  adminMenu.map((item, index) => (
                    <li className={item.cssClass} key={index}>
                      <a
                        href={item.href}
                        onClick={() => this.dropdownClick(item.value)}
                      >
                        <i className="fa fa-arrow-right"></i>
                        <span>{item.title}</span>
                      </a>
                      {item.subMenu.length > 0 && (
                        <div
                          className={
                            "sidebar-submenu" +
                            (isAccountOpen ? " display-menu" : "")
                          }
                        >
                          <ul>
                            {item.subMenu.map((subMenuItem, index) => (
                              <li key={index + "subMenu"}>
                                <a
                                  href={subMenuItem.href}
                                  className={subMenuItem.subMenucssClass}
                                >
                                  <i className="fa fa-circle"></i>
                                  {subMenuItem.subMenuTitle}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}
export default AdminSidebar;
